export { default } from './MapPointer';
